import React from 'react';
import { Button, Flex, useToast, Tr, Td } from '@chakra-ui/react';
import style from '../components/common/style';
import { ChecktableTwo } from '../components/common/ChecktableTwo';
import { colDeletedUser } from '../context/data';
import { MiniHeader } from '../components/common/customComponent';
import { useHistory } from 'react-router-dom';
import ApiManager from '../config/apiManager';
import LangContext from '../context/languageContext';
import { MdSettingsBackupRestore } from 'react-icons/md';

const DeletedUser = () => {
  let history = useHistory();
  const [dataa, setDataa] = React.useState([]);
  const { currentLangData } = React.useContext(LangContext);
  const [value, setValue] = React.useState('10');
  const [paginat, setpaginate] = React.useState();
  const [loader, setLoader] = React.useState(false);
  const [success, setSuccess] = React.useState(null);
  let apimanager = ApiManager.getInstance();
  const toast = useToast();
  // Creating Variable //
  let tempArray = [];
  React.useEffect(() => {
    getALLItems(value, 1);
  }, [value]);
  const getALLItems = (limit, page) => {
    setLoader(false);
    const body = {
      numRecords: limit,
      page: page,
    };
    apimanager
      .get('getAllDeletedUsers', body)
      .then(res => {
        // console.log('Response>>>', res);
        if (res.message === 3007) {
          res?.results?.docs?.map((value, index) => {
            tempArray.push(value);
          });
          setDataa(tempArray);
          setpaginate(res?.results);
          setLoader(true);
        }
        if (res.message === 7000) {
          toast({
            title: 'User Not Found',
            status: 'error',
            duration: 3000,
            isClosable: true,
            description: `User Not Found`,
          });
        }
        if (res.message === 5068) {
          toast({
            title: 'Something Went Wrong',
            status: 'error',
            duration: 3000,
            isClosable: true,
            description: `Server is not Responding`,
          });
        }
      })
      .catch(error => {
        console.log('error', error);
        setLoader(true);
      });
  };
  const RestoreUser = item => {
    //   console.log('Restore done', item.id);
    const body = {
      userId: item.userId,
    };
    console.log('body>>>>', body);
    apimanager
      .post('restoreDeletedUser', body)
      .then(response => {
        // console.log('response',response)
        if (response.message === 3008) {
          setSuccess('User Successfully Restored!');
          toast({
            title: success,
            status: 'success',
            duration: 3000,
            isClosable: true,
            description: `Restored, Please processed to List!`,
          });
          getALLItems(value, 1);
        }
      })
      .catch(error => {
        console.log(error);
      });
  };
  return (
    <Flex flexDirection={'column'}>
      <Flex {...style.miniheader}>
        {MiniHeader({
          title: 'Deleted Users',
          path: 'Dashboard',
          onclickForRoute: () => history.push('/Dashboard'),
          path2: 'Deleted Users',
        })}
      </Flex>
      <Flex {...style.box} background={'#fafdfb'} padding={10}>
        <Flex {...style.main}>
          <Flex {...style.buttoncontainer}>
            <Button
              {...style.createbutton}
              onClick={() => history.push('/CreateRole')}
            >
              Create
            </Button>
          </Flex>
          <ChecktableTwo
            datalist={dataa}
            TotDocs={paginat}
            loaderr={loader}
            headerNames={colDeletedUser}
            onPageChange={page => getALLItems(value, page)}
            renderItem={({ item, index }) => {
              console.log('renderitem', item);
              return (
                <Tr key={index} width={'100%'}>
                  <Td>{item?.email}</Td>
                  <Td>{item?.MSISDN}</Td>
                  <Td
                    position={'relative'}
                    display={'inline-flex'}
                    verticalAlign={'middle'}
                  >
                    <Button
                      {...style.Delbtn}
                      onClick={() => RestoreUser(item)}
                      variant={'outline'}
                      leftIcon={<MdSettingsBackupRestore size={'15px'} />}
                    >
                      {currentLangData?.app?.restore}
                    </Button>
                  </Td>
                </Tr>
              );
            }}
          />
        </Flex>
      </Flex>
    </Flex>
  );
};

export default DeletedUser;
